<template lang="html">
  <v-container>
    <v-card flat>
      <v-card-text>
        <h2 class="text-center" style="color: #144372; margin-top:35px;">นโยบายเว็บไซต์ของ  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย</h2>
        <p class="text-center">Website Policy of SME D Bank</p>
          <v-divider></v-divider><br>
        <ol>
          <li>
            <b>วัตถุประสงค์</b>
            <ul>

            <p><br>
              &nbsp;&nbsp;&nbsp;&nbsp;เว็บไซต์ ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทยได้จัดทำขึ้นเพื่อให้บริการ ในการใช้บริการข้อมูลข่าวสารแก่ประชาชนทั่วไป และ
              บุคลากรในสังกัด ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย ผู้ใช้บริการจะอยู่ภายใต้เงื่อนไขและข้อกำหนดดังต่อไปนี้ ผู้ใช้บริการจึงควร
              ศึกษาเงื่อนไข และ ข้อกำหนดการใช้งานเว็บไซต์ และ/หรือเงื่อนไขและข้อตกลงอื่นใดที่  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย ได้แจ้ง
                ให้ทราบบนเว็บไซต์โดยละเอียดก่อนการเข้าใช้บริการ ทั้งนี้ ในการใช้บริการให้ถือว่าผู้ใช้บริการได้ตกลงที่จะปฏิบัติ
              ตาม เงื่อนไขและข้อกำหนดการให้บริการที่กำหนดไว้นี้ หากผู้ใช้บริการไม่ประสงค์ที่จะผูกพันตามข้อกำหนดและ
              เงื่อนไขการให้บริการ ขอความกรุณาท่านยุติการเข้าชมและใช้งานเว็บไซต์นี้ในทันที</p>

            </ul>
          </li>
          <li>
            <b>เงื่อนไขและข้อกำหนดการใช้งานเว็บไซต์</b>
              <ul><br>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;
                    2.1 ผู้ใช้บริการอาจได้รับ เข้าถึง สร้าง ส่งหรือแสดงข้อมูล เช่น ไฟล์ข้อมูล ข้อความลายลักษณ์ อักษร
                    ซอฟต์แวร์คอมพิวเตอร์ ดนตรี ไฟล์เสียง หรือเสียงอื่นๆ ภาพถ่าย วิดีโอ หรือรูปภาพ อื่นๆ โดยเป็นส่วนหนึ่งของ
                    บริการหรือโดยผ่านการใช้บริการ ซึ่งต่อไปนี้จะเรียกว่า “เนื้อหา”</p>
                  <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    2.2 เนื้อหาที่นำเสนอต่อผู้ใช้บริการ อาจได้รับการคุ้มครองโดยสิทธิในทรัพย์สินทางปัญญาของ เจ้าของ
                    เนื้อหานั้น ผู้ใช้บริการไม่มีสิทธิเปลี่ยนแปลงแก้ไข จำหน่ายจ่ายโอนหรือสร้างผลงานต่อเนื่องโดยอาศัยเนื้อหา
                    ดังกล่าวไม่ว่าจะทั้งหมดหรือบางส่วน เว้นแต่ผู้ใช้บริการจะได้รับอนุญาตโดยชัดแจ้งจากเจ้าของเนื้อหานั้น
                  </p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;
                    2.3 ผู้ใช้บริการอาจพบเนื้อหาที่ไม่เหมาะสม หรือหยาบคาย อันก่อให้เกิดความไม่พอใจ ภายใต้ความเสี่ยง
                    ของตนเอง
                  </p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;
                    2.4  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย ทรงไว้ซึ่งสิทธิในการคัดกรอง ตรวจทาน ทำเครื่องหมาย เปลี่ยนแปลง แก้ไข
                  ปฏิเสธ หรือลบเนื้อหาใดๆ ที่ไม่เหมาะสมออกจากบริการ ซึ่ง ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย อาจจัดเตรียมเครื่องมือในการคัด
                  กรองเนื้อหาอย่างชัดเจน โดยไม่ขัดต่อกฎหมาย กฎ ระเบียบของทางราชการที่เกี่ยวข้อง
                  </p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;
                    2.5  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย อาจหยุดให้บริการเป็นการชั่วคราวหรือถาวร หรือยกเลิกการให้บริการ แก่
                  ผู้ใช้บริการรายใดเป็นการเฉพาะ หากการให้บริการดังกล่าวส่งผลกระทบต่อผู้ใช้บริการ อื่นๆ หรือขัดแย้งต่อ
                  กฎหมาย โดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
                  </p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;
                    2.6 การหยุดหรือการยกเลิกบริการตามข้อ 2.5 ผู้ใช้บริการจะไม่สามารถเข้าใช้บริการ และ เข้าถึง
                  รายละเอียดบัญชีของผู้ใช้บริการ ไฟล์เอกสารใดๆ หรือเนื้อหาอื่นๆ ที่อยู่ในบัญชีของ ผู้ใช้บริการได้
                  </p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;
                    2.7 ในกรณีท ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย หยุดให้บริการเป็นการถาวร หรือยกเลิกบริการแก่ ผู้ใช้บริการ
                   ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย มีสิทธิในการลบข้อมูลต่างๆ ที่อยู่ในบัญชีของผู้ใช้บริการได้ โดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบ
                  ล่วงหน้า</p>
              </ul>
          </li>
          <li>
            <b>สิทธิ หน้าที่ และความรับผิดชอบของผู้ใช้บริการ</b>
            <ul><br>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;
                3.1 ผู้ใช้บริการจะให้ข้อมูลเกี่ยวกับตนเอง เช่น ข้อมูลระบุตัวตนหรือรายละเอียดการติดต่อ ที่ถูกต้อง เป็น
                จริง และเป็นปัจจุบันเสมอ แก่  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย อันเป็นส่วนหนึ่งของ กระบวนการลงทะเบียนใช้บริการ หรือการ
                ใช้บริการที่ต่อเนื่อง
              </p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;
                3.2 ผู้ใช้บริการจะใช้บริการเว็บไซต์นี้ เพื่อวัตถุประสงค์ที่ได้รับอนุญาตตามข้อกำหนดของ
                 ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทยและไม่ขัดต่อกฎหมาย กฎ ระเบียบ ข้อบังคับ หลักปฏิบัติที่เป็นที่ ยอมรับโดยทั่วไป
              </p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;
                3.3 ผู้ใช้บริการจะไม่เข้าใช้หรือพยายามเข้าใช้บริการหนึ่งบริการใดโดยวิธีอื่น รวมถึงการใช้ วิธีการ
                อัตโนมัติ (การใช้สคริปต์) นอกจากช่องทางที่  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย จัดเตรียมไว้ให้ เว้นแต่ผู้ใช้บริการจะได้รับอนุญาต
                จาก  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย โดยชัดแจ้งให้ทำเช่นนั้นได้
              </p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;
                3.4 ผู้ใช้บริการจะไม่ทำหรือมีส่วนร่วมในการขัดขวางหรือรบกวนบริการของ ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย รวมทั้ง
              เครื่องแม่ข่ายและเครือข่ายที่เชื่อมต่อกับบริการ
              </p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;
                3.5 ผู้ใช้บริการจะไม่ทำสำเนา คัดลอก ทำซ้ำ ขาย แลกเปลี่ยน หรือขายต่อบริการเพื่อวัตถุประสงค์ใดๆ
              เว้นแต่ผู้ใช้บริการจะได้รับอนุญาตจาก ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย โดยชัดแจ้งให้ทำเช่นนั้นได้
              </p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;
                3.6 ผู้ใช้บริการมีหน้าที่ในการรักษาความลับของรหัสผ่านที่เชื่อมโยงกับบัญชีใดๆ ที่ใช้ในการเข้าถึงบริการ
              </p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;
                3.7 ผู้ใช้บริการจะเป็นผู้รับผิดชอบแต่เพียงผู้เดียวต่อบุคคลใดๆ รวมถึง  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย ในความเสียหาย
              อันเกิดจากการละเมิดข้อกำหนด
              </p>
            </ul>
          </li>
          <li>
              <b>การเชื่อมโยงกับเว็บไซต์อื่นๆ</b>
            <ul><br>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;
                4.1 การเชื่อมโยงไปยังเว็บไซต์อื่นเป็นเพียงการให้บริการเพื่ออำนวยความสะดวกแก่ผู้ใช้บริการ เท่านั้น
               ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย มิได้มีส่วนเกี่ยวข้องหรือมีอำนาจควบคุม รับรอง ความถูกต้อง ความน่าเชื่อถือ ตลอดจนความ
              รับผิดชอบในเนื้อหาข้อมูลของเว็บไซต์นั้น ๆ และ ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย ไม่รับผิดชอบต่อเนื้อหาใด ๆ ที่แสดงบน
              เว็บไซต์อื่นที่เชื่อมโยงมายัง เว็บไซต์ของ ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทยหรือต่อความเสียหายใด ๆ ที่เกิดขึ้นจากการเข้าเยี่ยมชม
              เว็บไซต์ดังกล่าวการเชื่อมโยงมายังเว็บไซต ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย
              </p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;
                4.2 กรณีต้องการเชื่อมโยงมายังเว็บไซต์ของ ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทยผู้ใช้บริการสามารถเชื่อมโยงมายังหน้าแรก
              ของเว็บไซต์ของ  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทยได้ โดยแจ้งความประสงค์เป็นหนังสือ แต่หากต้องการเชื่อมโยงมายังหน้าภายใน
              ของเว็บไซต์นี้ จะต้องได้รับความยินยอมเป็น หนังสือจาก ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทยแล้วเท่านั้น และในการให้ความยินยอม
              ดังกล่าว  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย ขอสงวนสิทธิที่จะกำหนดเงื่อนไขใด ๆ ไว้ด้วยก็ได้ ในการที่เว็บไซต์อื่น ที่เชื่อมโยงมายัง
              เว็บไซต์ของ  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย จะไม่รับผิดชอบต่อเนื้อหาใด ๆ ที่แสดงบนเว็บไซต์ที่เชื่อมโยงมายังเว็บไซต์ของ
               ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทยหรือต่อความเสียหายใด ๆ ที่เกิดขึ้นจากการใช้เว็บไซต์เหล่านั้น
              </p>
            </ul>
          </li>
          <li>
            <b>การปฏิเสธความรับผิด</b>
            <ul><br>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;
                5.1  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทยจะไม่รับผิดต่อความเสียหายใด ๆ รวมถึง ความเสียหาย สูญเสียและค่าใช้จ่ายที่
                เกิดขึ้นไม่ว่าโดยตรงหรือโดยอ้อม ที่เป็นผลหรือสืบเนื่องจากการที่ผู้ใช้เข้าใช้เว็บไซต์นี้หรือเว็บไซต์ที่เชื่อมโยงกับ
                เว็บไซต์นี้ หรือต่อความเสียหาย สูญเสียหรือค่าใช้จ่ายที่ เกิดจากความล้มเหลวในการใช้งาน ความผิดพลาด การละ
                เว้น การหยุดชะงัก ข้อบกพร่อง ความไม่สมบูรณ์ คอมพิวเตอร์ไวรัส ถึงแม้ว่า  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย จะได้รับแจ้งว่า
                อาจจะ เกิดความเสียหาย สูญเสียหรือค่าใช้จ่ายดังกล่าวขึ้น นอกจากนี้  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย ไม่รับผิดต่อผู้ใช้เว็บไซต์
                หรือบุคคลจากการเรียกร้องใด ๆ ที่เกิดขึ้นจากบนเว็บไซต์ หรือเนื้อหาใด ๆ ซึ่งรวมถึงการตัดสินใจหรือการกระทำ
                ใด ๆ ที่เกิดจากความเชื่อถือในเนื้อหาดังกล่าวของ ผู้ใช้เว็บไซต์ หรือในความเสียหายใด ๆ ไม่ว่าความเสียหาย
                ทางตรง หรือทางอ้อม รวมถึงความเสียหายอื่นใดที่อาจเกิดขึ้นได้ผู้ใช้บริการยอมรับและตระหนักดีว่า
                 ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทยจะไม่ต้องรับผิดชอบต่อการกระทำใดของผู้ใช้บริการทั้งสิ้น
          </p>
            </ul>
          </li>
          <li>
            <b>กรรมสิทธิ์และสิทธิในทรัพย์สินทางปัญญา</b>
            <ul><br>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;
                6.1  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทยหรือผู้ให้อนุญาตแก่ ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย เป็นผู้มีสิทธิตามกฎหมายแต่ เพียงผู้เดียวใน
              กรรมสิทธิ์ ผลประโยชน์ทั้งหมด รวมถึงสิทธิในทรัพย์สินทางปัญญาใดๆ ที่มี อยู่ในบริการซึ่ง  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย หรือ
              ผู้ให้อนุญาตแก่  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย เป็นผู้จัดทำขึ้น ไม่ว่าสิทธิเหล่านั้นจะได้รับการจดทะเบียนไว้หรือไม่ก็ตาม
              </p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;
                6.2 ผู้ใช้บริการจะต้องไม่เปิดเผยข้อมูลที่  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย กำหนดให้เป็นความลับ โดยไม่ได้รับความ
              ยินยอมเป็นลายลักษณ์อักษรล่วงหน้าจาก  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย
              </p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;
                6.3 ผู้ใช้บริการจะต้องไม่ใช้ชื่อทางการค้า เครื่องหมายการค้า เครื่องหมายการบริการ ตราสัญลักษณ์ ชื่อ
              โดเมนของ  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย โดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรจาก ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย
              </p>
            </ul>
          </li>
          <li>
            <b>กฎหมายที่ใช้บังคับ</b>
            <ul><br>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;
                7.1 การตีความ และการบังคับตามเงื่อนไขการให้บริการฉบับนี้ ให้เป็นไปตามกฎหมายไทย
              </p>
            </ul>
          </li>
        </ol>
        <br><br><br><br>
        <p style="text-align: right;">
          นโยบายเว็บไซต์ของ  ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย<br>
          Website Policy of SME D Bank <br>
          จัดทำเมื่อวันที่ 1 มกราคม 2567
        </p>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
.text-center {
  text-align: center;
}
</style>
